<template>
  <div class="v-checkbox-question-wrap">
    <div class="v-question-title font-size-18 margin-b-8">
      <span class="required" v-if="question.required">*</span>
      {{ question.name }}
    </div>
    <div class="v-checkbox-group">
      <el-collapse accordion>
      <el-checkbox-group v-model="valArr">
        <div :class="[item.subAnswerList.length >= 1?'margin-tb-5':'margin-tb-24']" v-for="(item, index) in question.answerList" :key="item.id">
          <div v-if="item.subAnswerList.length < 1">
            <el-checkbox :id="item.id" :label="item.id" @change="cb(item, index)">{{item.name}}</el-checkbox>
            <input class="input-border" type="text" v-if="item.input" :disabled="!item.checked" v-model="item.inputResult" />
          </div>
          <!-- 多级 -->
          <el-collapse-item :title="item.name" :name="index" v-if="item.subAnswerList.length >= 1">
          <div>
            <!-- <div class="v-title2 font-size-16 margin-tb-24">{{ item.name }}</div> -->
            <div class="padding-left-25 margin-tb-24" v-for="(item2, index2) in item.subAnswerList" :key="index2">
              <el-checkbox :label="item2.id" @change="cb(item2, index2)">{{item2.name}}</el-checkbox>
              <input class="input-border" type="text" v-if="item2.input" :disabled="!item2.checked" v-model="item2.inputResult" />
            </div>
          </div>
          </el-collapse-item>
          <!--  -->
        </div>
      </el-checkbox-group>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    questionData: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {
      valArr: [],
      answerList: [],
      question: {...this.questionData}
    }
  },
  watch: {
    questionData() {
      this.valArr=[];
      this.answerList=[];
      this.question = {...this.questionData}
      this.defaultSelect()
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    cb(param) {
      let ev = event || window.event
      let target = ev.target || ev.srcElement
      param.checked = target.checked
      let arr = { ...this.answerList }
      if (!target.checked) {
        //取消选中
        if (param.input) {
          //其他输入框内容清空
          param.inputResult = ''
        }
        delete arr[param.id]
      } else {
        arr[param.id] = param
      }
      this.answerList = arr
      sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(this.question))
      this.$emit('update:answer', arr) //传给父组件
    },
    defaultSelect() {
      //默认值
      let _this = this
      let arr = _this.question.answerList
      let dObj = {}
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        let subArr = obj.subAnswerList
        if (subArr.length > 0) {
          //多级题
          for (let j = 0; j < subArr.length; j++) {
            let subObj = subArr[j]
            if (subObj.checked) {
              _this.valArr.push(subObj.id)
              dObj[subObj.id] = subObj
            }
          }
        } else {
          //1级题
          if (obj.checked) {
            _this.valArr.push(obj.id)
            dObj[obj.id] = obj
          }
        }
      }
      if(JSON.stringify(dObj)!=='{}'){
        _this.answerList=dObj
        sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(this.question))
        this.$emit('update:answer', dObj)
      }
    }
  },
  created() {
    this.defaultSelect()
  }
}
</script>
<style lang="stylus" scoped>
.v-checkbox-question-wrap{
  width 500px
  margin auto  
  .v-question-title{
    text-align left  
  }

  .v-checkbox-group /deep/ .el-checkbox-group {
      & > div:last-child {
          .el-collapse-item__header {
            border-color: transparent;
          }
      }
  }
}
.required{
    color:red;
    font-size:16px;
}
.margin-tb-24{
  margin:24px 0;
}
.input-border{
  border:1px solid $color-black-15;
  height:20px;
  padding:5px;
}
input:disabled{
  background-color: $color-gray-f5;
  border-color: $color-gray-e5;
}
.padding-left-25{
  padding-left:25px;
}
.margin-tb-5{
  margin:5px 0;
}
.v-checkbox-group{
  margin-bottom 30px
}
</style>
